<div class="flex flex-col gap-4">
    <div class="grid grid-cols-6 gap-4 mb-8">
        <ng-container *ngFor="let color of colors">
            <ng-container *ngFor="let size of sizes">
                <ng-container *ngFor="let disabled of size.includeDisabled ? [false, true] : [false]">
                    <ng-container *ngFor="let weight of weights">
                        <ng-container *ngFor="let kind of kinds">
                            <ng-container [ngSwitch]="kind">
                                    <dropdown [color]="color" [text]="'button'" [size]="size.class" [variant]="kind"
                                        [bold]="weight.class === 'button-bold'" [disabled]="disabled"
                                        [items]="[
            { title: 'Item A1' }, { title: 'Item A2' }, { title: 'Item A3' }, { title: 'Item A4' }, { title: 'Item A5' },
            { title: 'Item B1' }, { title: 'Item B2' }, { title: 'Item B3' }, { title: 'Item B4' }, { title: 'Item A5' },]"></dropdown>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        </ng-container>
    </div>
</div>